import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c4d609c4&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c4d609c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d609c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d609c4')) {
      api.createRecord('c4d609c4', component.options)
    } else {
      api.reload('c4d609c4', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c4d609c4&scoped=true&", function () {
      api.rerender('c4d609c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zpk3kgy1cvL6/JS/comp/SearchFilterTokens.vue"
export default component.exports